import { Game } from './game';
import { MobileUtils } from './utils/MobileUtils';
import { loadLanguagePreference } from './i18n/lang';

// Initialize mobile settings if on mobile device
let mobileCleanup: (() => void) | null = null;

function initializeGame(): void {
  // Load language preference
  loadLanguagePreference();
  
  // Initialize mobile settings
  const deviceInfo = MobileUtils.getDeviceInfo();
  console.log('Device Info:', deviceInfo);
  
  if (deviceInfo.isMobile || deviceInfo.isTablet) {
    mobileCleanup = MobileUtils.initializeMobileSettings();
    console.log('Mobile settings initialized');
  }
  
  // Apply performance settings based on device
  const performanceSettings = MobileUtils.getPerformanceSettings();
  console.log('Performance settings:', performanceSettings);
  
  // Create and start the game
  const game = new Game();
  
  // Handle orientation changes
  if (deviceInfo.isMobile) {
    MobileUtils.onOrientationChange((newDeviceInfo) => {
      console.log('Orientation changed:', newDeviceInfo);
      
      // Optionally restart the game or adjust settings
      if (newDeviceInfo.orientation !== deviceInfo.orientation) {
        // Could trigger a game resize or notification here
        console.log('Orientation changed from', deviceInfo.orientation, 'to', newDeviceInfo.orientation);
      }
    });
  }
  
  // Handle page visibility changes (for mobile battery optimization)
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      // Game paused/minimized
      console.log('Game paused (page hidden)');
    } else {
      // Game resumed
      console.log('Game resumed (page visible)');
    }
  });
  
  // Handle window resize for responsive design
  window.addEventListener('resize', () => {
    // Force device info refresh
    MobileUtils.getDeviceInfo();
  });
}

// Cleanup on page unload
window.addEventListener('beforeunload', () => {
  if (mobileCleanup) {
    mobileCleanup();
  }
});

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeGame);
} else {
  initializeGame();
} 